module.exports = __webpack_public_path__ + "static/img/aimeikongjian_icon.3659ae6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/aimeikongjian_icon.png
// module id = EOdr
// module chunks = 1